// extracted by mini-css-extract-plugin
module.exports = {"SignUp":"SignUp_SignUp__xP8H4"};